import { DependencyList, useEffect, useRef } from 'react';

// Horizontal scrollbar above a wide PrimeReact DataTable, kept in sync with the table's own one.
export const useTopScrollbar = (deps: DependencyList) => {
    const tableWrapperRef = useRef<HTMLDivElement>(null);
    const topScrollRef = useRef<HTMLDivElement>(null);
    const topScrollContentRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const wrapperEl = tableWrapperRef.current?.querySelector<HTMLDivElement>('.p-datatable-wrapper');
        const topEl = topScrollRef.current;
        const topContentEl = topScrollContentRef.current;
        if (!wrapperEl || !topEl || !topContentEl) return;

        const syncWidth = () => {
            topContentEl.style.width = `${wrapperEl.scrollWidth}px`;
        };
        syncWidth();

        let syncing = false;
        const onTopScroll = () => {
            if (syncing) return;
            syncing = true;
            wrapperEl.scrollLeft = topEl.scrollLeft;
            syncing = false;
        };
        const onTableScroll = () => {
            if (syncing) return;
            syncing = true;
            topEl.scrollLeft = wrapperEl.scrollLeft;
            syncing = false;
        };

        const resizeObserver = new ResizeObserver(syncWidth);
        resizeObserver.observe(wrapperEl);
        topEl.addEventListener('scroll', onTopScroll);
        wrapperEl.addEventListener('scroll', onTableScroll);

        return () => {
            resizeObserver.disconnect();
            topEl.removeEventListener('scroll', onTopScroll);
            wrapperEl.removeEventListener('scroll', onTableScroll);
        };
    }, deps); // eslint-disable-line react-hooks/exhaustive-deps

    return { tableWrapperRef, topScrollRef, topScrollContentRef };
};
